import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Card, Group, Image, NumberFormatter, Stack, Text, Title } from '@mantine/core';
import { DetailStepper } from './DetailStepper';
import { TransactionDetail } from './TransactionDetail';
export type DetailCardProps = {
  coinImg: string;
  coinValue: number;
  status: string;
  txID: string;
  orderID: string;
  time: string;
};
export const DetailCard: React.FC<DetailCardProps> = ({
  coinImg,
  coinValue,
  status,
  txID,
  orderID,
  time
}) => {
  const {
    i18n
  } = useLingui();
  return <Card radius={5} bg="var(--navbar-bg-color)" w="100%" p={{
    base: 10,
    sm: 24
  }}>
      <Stack gap={20}>
        <Title fz={{
        base: 14,
        sm: 18
      }} className={gunterzBold.className} mt={20} ta="center">
          {i18n._('Transaction details')}
        </Title>
        <Group align="center" justify="center" gap={10} mt={{
        base: 0,
        md: 20
      }}>
          <Image src={coinImg} alt="coin" w={{
          base: 48,
          sm: 56
        }} h={{
          base: 48,
          sm: 56
        }} />
          <Text className={gunterzBold.className} fz={{
          base: 20,
          sm: 32
        }} mt={8}>
            <NumberFormatter value={coinValue} prefix={coinValue > 0 ? '+' : '-'} suffix=" USDT" />
          </Text>
        </Group>

        <TransactionDetail status={status} txID={txID} orderID={orderID} time={time} />

        <Title fz={{
        base: 14,
        sm: 18
      }} className={gunterzBold.className} c="var(--text-white)" mt={20}>
          {i18n._('Order progress')}
        </Title>

        <DetailStepper />
      </Stack>
    </Card>;
};